import { createFileRoute, redirect } from '@tanstack/react-router';

/** `/` → `/today`, per design §2.2. */
export const Route = createFileRoute('/')({
  beforeLoad: () => {
    throw redirect({ to: '/today' });
  },
});
